import type {ReactElement, PropsWithChildren} from 'react'
import React, {createElement} from 'react'

const ALLOWED_HEADING_TAGS = ['h1', 'h2', 'h3', 'h4'] as const
export {ALLOWED_HEADING_TAGS}
export type HeaderCardTitleTag = (typeof ALLOWED_HEADING_TAGS)[number]

interface HeaderCardProps extends Required<PropsWithChildren> {
	title: string | ReactElement
	titleTag?: HeaderCardTitleTag
	className?: string
	backgroundColor?: string
}

export const HeaderCard = ({
	title = '',
	titleTag = 'h1',
	children = null,
	className = '',
	backgroundColor = 'bg-white',
}: HeaderCardProps): ReactElement => {
	const safeTag = ALLOWED_HEADING_TAGS.includes(titleTag) ? titleTag : 'h1'
	return (
		<div
			className={`p-6 md:rounded-lg md:p-8 ${className} ${backgroundColor}`}
		>
			{createElement(safeTag, null, title)}
			{children}
		</div>
	)
}
